<template>
  <div class="content extended-forms">
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <ArtistSelect
            class="col-md-6"
            @memberChangeEvent="getArtistInfo"
            :is-filter="true"
            :include-unit-artist="true"
            :show-members="false"
            :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
          />
        </div>
      </div>
      <div class="col-md-6">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-6">
            <el-select class="select-primary" size="large" placeholder="분류" v-model="option" @change="getHotFanLogs(1)">
              <el-option v-for="option in options" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3" v-for="(item, index) in list">
        <CardLayout
          :key="index"
          :contentId="item.id"
          :scheduleId="item.scheduleId"
          :scheduleUrl="item.scheduleUrl"
          :fileIds="item.fileIds"
          :title="item.contents"
          :state="item.state"
          :regDate="item.displayTime"
          :startTime="item.startTime"
          :endTime="item.endTime"
          :btnDelete="true"
          :btnDetail="true"
          @contentDetail="goFanLogDetail"
          @deleteContent="deleteFanLogFromHot"
        />
      </div>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import CardLayout from "@/pages/Components/CardLayout.vue";
import { BasePagination } from "@/components/index";
import swal from "sweetalert2";
import { URLUtils } from "@/util/URLUtils";
import { formatDateTime } from "@/util/DateUtils";

export default {
  components: {
    ArtistSelect,
    CardLayout,
    BasePagination,
  },
  async created() {
    if (this.$route.query.option) {
      this.option = Number(this.$route.query.option);
    }
  },
  data() {
    return {
      list: [],
      option: 0,
      options: [
        { label: "전체", value: 0 },
        { label: "최신", value: 1 },
        { label: "추천", value: 2 },
      ],
      currentPage: 1,
      totalPages: 1,
      unitId: null,
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.getHotFanLogs(this.currentPage);
      },
    },
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      await this.getHotFanLogs();
    },
    async getHotFanLogs(page) {
      const queryParams = {
        unitId: this.unitId,
        option: this.option,
      };
      const params = { unitId: this.unitId, option: this.option };
      params.currentPage = page ? page : 1;

      const path = `/fanLog/hotFanLogs?${URLUtils.objectToQueryString(queryParams)}`;
      if (this.$route.fullPath !== path) {
        try {
          await this.$router.push(path);
        } catch (ex) {}
      }
      if (!params.unitId) {
        window.Toast.error("잘못된 접근입니다");
        return;
      }
      return this.$axios
        .get(`/fanLogs/hot`, {
          params,
        })
        .then((res) => {
          this.list = res.data.data.data.map((d) => {
            d.displayTime = formatDateTime(d.displayTime);
            d.startTime = formatDateTime(d.startTime);
            d.endTime = formatDateTime(d.endTime);
            return d;
          });
          this.totalPages = Number(res.data.data.page);
          for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].scheduleId) {
              this.list[i].scheduleUrl = `/schedules/scheduleForm?scheduleId=${this.list[i].scheduleId}&unitId=${this.list[i].unitId}`;
            }
            if (this.list[i].imageIds) {
              this.list[i].fileIds = this.list[i].imageIds.split(",");
            }
          }
        });
    },

    async deleteFanLogFromHot(param) {
      const contentId = param.contentId;
      swal
        .fire({
          title: "인기 삭제 확인",
          text: `${contentId}번 팬로그를 인기 해제 하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .delete(`/fanLogs/${contentId}/hot`, {
                  params: { unitId: this.unitId },
                })
                .then((res) => {
                  window.Toast.success("팬로그가 인기 해제 되었습니다");
                  this.getHotFanLogs();
                });
            } catch (err) {
              window.Toast.error("팬로그가 인기 해제 중 에러가 발생하였습니다.");
            }
          }
        });
    },

    goFanLogDetail(param) {
      this.$router.push(`/fanLog/fanLogDetail?fanLogId=${param.contentId}`);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  .row {
    margin-bottom: 20px;
  }
}
</style>
